export default "dist/images/block-blockquote-highlight.2e6ac48.png";